import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import NomenclatureDataTable from "@/components/nomenclatures/nomenclature-table/nomenclature-data-table";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-permissions";

const nomenclaturesSearchSchema = z.object({
  page: z.number().optional().default(1),
  search: z.string().optional(),
});

export const Route = createFileRoute(
  "/_authenticated/settings/_layout/nomenclatures",
)({
  validateSearch: nomenclaturesSearchSchema,
  component: NomenclaturesPage,
});

function NomenclaturesPage() {
  const searchParams = Route.useSearch();

  return (
    <RouteGuardPermissions
      permissions={[{ module: "nomenclature", actions: ["read", "update"] }]}
    >
      <NomenclatureDataTable
        currentPage={searchParams.page}
        pageSize={5}
        basePath="/settings/nomenclatures"
        searchParams={searchParams}
      />
    </RouteGuardPermissions>
  );
}
